import { useMemo } from 'react';
import '../styles/components/SkyParticles.css';

const randomBetween = (min, max) => Math.random() * (max - min) + min;

function buildClouds(count, reduceMotion) {
  return Array.from({ length: count }, (_, index) => ({
    key: `cloud-${index}`,
    className: `cloud cloud--${index % 2 === 0 ? 'ltr' : 'rtl'}`,
    style: {
      top: `${randomBetween(2, 85)}vh`,
      opacity: String(randomBetween(0.28, 0.52)),
      '--cloud-scale': String(randomBetween(0.55, 1.15)),
      ...(reduceMotion ? { left: `${randomBetween(2, 88)}vw` } : {}),
      animationDuration: `${randomBetween(65, 130)}s`,
      animationDelay: `${-randomBetween(0, 100)}s`,
    },
  }));
}

function buildSparkles(count) {
  return Array.from({ length: count }, (_, index) => {
    const twinkleDuration = randomBetween(2.5, 5.5);
    const driftDuration = randomBetween(12, 30);

    return {
      key: `sparkle-${index}`,
      className: `sparkle${Math.random() > 0.45 ? ' blue' : ''}${Math.random() > 0.7 ? ' large' : ''}`,
      style: {
        left: `${randomBetween(0, 100)}vw`,
        top: `${randomBetween(0, 100)}vh`,
        animation:
          `sparkleTwinkle ${twinkleDuration}s ease-in-out ${-randomBetween(0, twinkleDuration)}s infinite, ` +
          `sparkleDrift ${driftDuration}s linear ${-randomBetween(0, driftDuration)}s infinite alternate`,
        '--drift-x': `${randomBetween(-30, 30)}px`,
        '--drift-y': `${randomBetween(-60, -20)}px`,
      },
    };
  });
}

export function SkyParticles() {
  const { clouds, sparkles } = useMemo(() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    return {
      clouds: buildClouds(reduceMotion ? 5 : 11, reduceMotion),
      sparkles: buildSparkles(reduceMotion ? 22 : 64),
    };
  }, []);

  return (
    <div className="sky-particles" aria-hidden="true">
      <div className="cloud-layer">
        {clouds.map(({ key, className, style }) => (
          <div key={key} className={className} style={style} />
        ))}
      </div>
      <div className="sparkle-layer">
        {sparkles.map(({ key, className, style }) => (
          <div key={key} className={className} style={style} />
        ))}
      </div>
    </div>
  );
}
